import bwipjs from "bwip-js";
/**
 * Shared bwip-js render options for every output format so the on-screen preview
 * and all downloads share identical geometry.
 *
 * `includetext: true` renders the human-readable digits below the bars (the
 * "spodní varianta" / bottom variant requested by the assignment) in bwip-js's
 * own font.
 */
var buildOptions = function (text, symbology) { return ({
    bcid: symbology,
    text: text,
    includetext: true,
    scale: 3,
    height: 12,
}); };
var toCanvas = bwipjs.toCanvas;
/**
 * Generates a vector SVG barcode for a product number value.
 *
 * @param text the ISBN/ISMN to encode (dashes are allowed)
 * @param symbology the bwip-js symbology, see `detectSymbology`
 * @returns the SVG document as a string
 * @throws when bwip-js cannot encode the given text (e.g. an invalid ISBN)
 */
export var generateBarcodeSvg = function (text, symbology) { return bwipjs.toSVG(buildOptions(text, symbology)); };
/**
 * Generates a raster PNG barcode and returns it as a `data:` URL.
 *
 * Uses an off-DOM `<canvas>` element, so it must run in a browser environment.
 *
 * @param text the ISBN/ISMN to encode (dashes are allowed)
 * @param symbology the bwip-js symbology, see `detectSymbology`
 * @returns a `data:image/png;base64,...` URL
 * @throws when bwip-js cannot encode the given text
 */
export var generateBarcodePngDataUrl = function (text, symbology) {
    var canvas = document.createElement("canvas");
    toCanvas(canvas, buildOptions(text, symbology));
    return canvas.toDataURL("image/png");
};
